import { CallcardListFreeTextComponent } from '@addins/listcallcards/components/callcard-list-free-text/callcard-list-free-text.component';
import { Injectable } from '@angular/core';
import { ProfileReaderService } from '@services/profile-reader/profile-reader.service';
import { AddinExecute, Execute } from '@techwan/ionic-core';
import { CallcardListEngagedVehiclesComponent } from '../../../components/callcard-list-engaged-vehicles/callcard-list-engaged-vehicles.component';
import { CallCardGroupsService } from '../../callcard-groups/callcard-groups.service';
import { CustomComponentsService } from '../../custom-components/custom-components.service';
import { EngagedUnitsService } from '../../engaged-units/engaged-units.service';
import { CallCardListFiltersService } from '../../filters/callcard-list-filters/callcard-list-filters.service';
import { PriorityFilterService } from '../../filters/priority-filter/priority-filter.service';
import { ResponsibilityFilterService } from '../../filters/responsibility-filter/responsibility-filter.service';

interface ICallcardListFilter {
  name: string;
  defaultValue?: any;
}

@AddinExecute({
  name: 'CallcardListSetup',
  description: 'setup callcards list'
})
@Injectable()
export class CallcardListSetupService extends Execute {
  constructor(
    private profileReader: ProfileReaderService,
    private callcardListFilters: CallCardListFiltersService,
    private priorityFilter: PriorityFilterService,
    private responsibilityFilter: ResponsibilityFilterService,
    private engagedUnits: EngagedUnitsService,
    private customComponents: CustomComponentsService,
    private callcardGroups: CallCardGroupsService
  ) {
    super();
  }

  execute() {
    this.initFilters();
    this.initGroups();

    this.initCustomComponents();
  }

  private initFilters() {
    const filters: ICallcardListFilter[] = this.profileReader.getComponentConfig('listcallcards', 'filters', []);
    if (filters.findIndex(filter => filter.name == 'Priority') >= 0) {
      this.priorityFilter.setup();
      this.callcardListFilters.addFilter(this.priorityFilter);
    }
    const responsibilityFilter = filters.find(filter => filter.name == 'Responsibility');
    if (responsibilityFilter) {
      this.responsibilityFilter.setup(responsibilityFilter.defaultValue);
      this.callcardListFilters.addFilter(this.responsibilityFilter);
    }
  }

  private initGroups() {
    const grouping: string = this.profileReader.getComponentConfig('listcallcards', 'grouping', '');
    this.callcardGroups.setup(grouping);
  }

  private initCustomComponents() {
    const showEngagedVehicles: boolean = this.profileReader.getComponentConfig('listcallcards', 'showEngagedVehicles', false);
    if (showEngagedVehicles) {
      this.engagedUnits.setup();

      this.customComponents.add({ component: CallcardListEngagedVehiclesComponent });
    }

    const showFreeTextTypes: number[] = this.profileReader.getComponentConfig('listcallcards', 'showFreeTextTypes', []);
    if (showFreeTextTypes?.length) {
      this.customComponents.add({ component: CallcardListFreeTextComponent });
    }
  }
}
